//import React,{ useState, useEffect } from "react";
import {
  Button,
  IconButton,
  TextField,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import {
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadIcon from "@mui/icons-material/Download";
//import React, { useState, useEffect,useCallback } from "react";
import "../Standard-MLFB/standard-mlfb.css";
import SnackbarCustom from "../../../components/Snackbar/Snackbar";
import { useSelector, useDispatch } from "react-redux";
import {
  getStdMLFBData,
  SearchGetStandardMLFB,
  deleteStandarsMLFB,
  createStandardMLFB,
  editStandardMLFB,
  ExportStandatdMLFB
} from "../../../redux/API/api_standardMLFB";
// import ZCodePopup from "./z-code-dialog";
import React, { useState, useEffect, useCallback } from "react";
//import SnackbarCustom from "../../../components/Snackbar/Snackbar";
import { BootstrapInput } from "../../../Utilities/utility";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { zcodes } from "../../../redux/Actions/actions";
import * as XLSX from "xlsx";
import StandardMLFBPop from "./standard-mlfb-dialog";
import * as FileSaver from 'file-saver';
import { getPreviewDrawing } from "../../../redux/API/api_uploadDrawing";
import Loading from "../../../components/Loading/Loading";
import { PreviewOutlined } from "@mui/icons-material";

export default function StandardMLFB() {
  const [editStdMlfb, setEditStdMlfb] = useState(false);
  const [rows, setRows] = useState([]);
  const [mlfbs, setMLFBS] = useState('');
  const [initialRows, setInitialRows] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [mlfbSearch, setMlfbSearch] = useState("");
  const [descriptionSearch, setDescriptionSearch] = useState("");
  const [itemNoSearch, setItemNoSearch] = useState("");
  const [drawingSearch, setDrawingSearch] = useState("");
  const [openForDelete, setOpenForDelete] = useState(false);
  const [deleteUser, setDeleteUser] = useState([]);

  const [loaderUploading, setUploading] = useState(false);

  const UID = useSelector((state) => state.saveUserIdReducer);
  const userdetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const siteToken = useSelector((state) => state.saveTokenReducer);
  const azureToken = useSelector((state) => state.saveAzureTokenReducer);

  const columns = [
    { field: "mlfb", headerName: "MLFB", width: 200, sortable: true },
    { field: "itemno", headerName: "Item No", width: 200 },
    { field: "drawingNo", headerName: "Drawing No", width: 200 },
    {
      field: "preview",
      headerName: "Preview Diagram",
      width: 200,
      renderCell: (params) => (
        <IconButton color="primary">
          <PreviewOutlined style={{ cursor: "pointer" }} onClick={() => onPreview(params)} />
        </IconButton>
      ),
    },
    { field: "description", headerName: "Description", width: 200 },
    { field: "mrp", headerName: "MRP", width: 200 },
    // { field: "cost", headerName: "Cost", width: 200 },
    {
      field: "isActive",
      headerName: "Is Active",
      width: 200,
      renderCell: (params) => (
        <span
          className={`status-indicator ${params.value ? "green" : "grey"}`}
        ></span>
      ),
    },
    {
      field: "action",
      headerName: "Actions",
      flex: 0.5,
      sortable: false,
      width: "100px",

      renderCell: (params) => (
        <div>
          <IconButton
            color="primary"
            disabled={userdetails?.roleId == 2}
            onClick={() => handleEditStdMlfb(params.row)}
          >
            <EditIcon style={{ cursor: "pointer" }} />
          </IconButton>
          <IconButton
            disabled={userdetails?.roleId == 2}
            onClick={() => handleDelete(params.row)}>
            <DeleteIcon />
          </IconButton>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getTableData();
  }, []);

  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };

  function getTableData() {
    setIsLoader(true);
    let input = {};
    input.mlfb = null;

    getStdMLFBData(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.roleName,
      userdetails.gid,
      userdetails.roleId,
      input
    )
      .then((response) => {
        setInitialRows(response);
        setRows(response);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log("Error: " + error, "error");
        setIsLoader(false);
      });
  }

  const handleChangeMLFB = (e) => {
    setMlfbSearch(e.target.value);
  };
  const handleChangeItemNo = (e) => {
    setItemNoSearch(e.target.value);
  };
  const handleChangeDescription = (e) => {
    setDescriptionSearch(e.target.value);
  };
  const handleChangeDrawingNo = (e) => {
    setDrawingSearch(e.target.value);
  };


  function onPreview(params) {
    setUploading(true);
    let mlfbID = params?.row?.standardMLFBID;
    getPreviewDrawing(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      mlfbID
    )
      .then((response) => {
        setUploading(false);
        const pdfUrl = response?.fileUrl || "";
        console.log("pdfurl", pdfUrl);
        pdfUrl
          ? window.open(pdfUrl, "_blank")
          : response?.result ? handleSnackOpen(
            response?.result,
            "warning"
          ) : handleSnackOpen(
            "Error while downloading Preview Drawing.",
            "error"
          );
      })
      .catch((error) => {
        setUploading(false);
        handleSnackOpen("Error while downloading Preview Drawing.", "error");
      });
  }

  const handleDelete = (zcodedata) => {
    console.log(zcodedata);
    setOpenForDelete(true);
    setDeleteUser(zcodedata);
  };

  const handleCloseforDelete = () => {
    setOpenForDelete(false);
    setDeleteUser([]);
  };

  const handleClose = (e) => {
    setOpen(false);
  };



  function exportToExcel() {
    setIsLoader(true);
    let MLFB = null;
    ExportStandatdMLFB(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      MLFB)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.byteLength <= 200) {
            setIsLoader(false);
            handleSnackOpen();
            setSnackMessage("No Records are Found ");
            setAlertType("success");
          } else {
            var blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            FileSaver.saveAs(blob, "Standard MLFB Report.xlsx");
            setIsLoader(false);
            handleSnackOpen();
            setSnackMessage("Standard MLFB Report Downloaded");
            setAlertType("success");
          }
        } else {
          setIsLoader(false);
          handleSnackOpen();
          setSnackMessage("Standard MLFB Report failed");
          setAlertType("error");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        handleSnackOpen();
        setSnackMessage("Error: ", error);
        setAlertType("error");
      });
  }



  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchText(value);
    const filteredRows = initialRows.filter((row) =>
      Object.values(row).some((field) =>
        field ? field.toString().includes(value) : ""
      )
    );
    setRows(filteredRows);
  };

  const handleSearChange = () => {
    setIsLoader(true);
    let input = {};
    input.mlfb = mlfbSearch;
    input.description = descriptionSearch;
    input.itemno = itemNoSearch;
    input.drawingNo = drawingSearch;

    SearchGetStandardMLFB(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      input
    )
      .then((response) => {
        if (response) {
          //handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          setRows(response);
          // getTableData();
        } else {
          // handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        //handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };

  const handleReset = () => {
    setMlfbSearch("");
    setDescriptionSearch("");
    setItemNoSearch("");
    setDrawingSearch("");
    setRows(initialRows);
  };

  const handleRowDelete = () => {
    console.log(deleteUser.standardMLFBID);
    setIsLoader(true);
    setOpenForDelete(false);
    deleteStandarsMLFB(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      deleteUser.standardMLFBID
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          getTableData();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };

  const handleEditStdMlfb = (editData) => {
    setEditStdMlfb(editData);
    setOpenDialog(true);
  };

  const handleUpdateStdMLFB = (newuser) => {
    handleRowUpdate(newuser);
    setOpenDialog(false);
  };
  const handleRowUpdate = (prevData) => {
    delete prevData.Countries;
    delete prevData.DBSeries;
    delete prevData.DBType;
    delete prevData.NoOfWays;
    delete prevData.Variants;
    console.log(prevData);

    const formData = new FormData();
    formData.append("Cost", prevData.txtCost);
    formData.append("MLFB", prevData.txtMLFB);
    formData.append("Description", prevData.txtDescription);
    formData.append("ITEMNO", prevData.txtItemNO);
    formData.append("DrawingNo", prevData.txtDrawingNo);
    formData.append("MRP", prevData.txtMRP);
    formData.append("userID", userdetails.userId);
    formData.append("StandardMLFBID", prevData.StandardMLFBID);
    formData.append("IsActive", prevData.isActive);

    setOpenDialog(false);
    setIsLoader(true);
    editStandardMLFB(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      formData
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          getTableData();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };

  const handleSaveStdMlfb = (newUser) => {
    setOpenDialog(false);
    handleRowAdd(newUser);
  };

  const handleRowAdd = (newTableData) => {
    const formData = new FormData();
    formData.append("txtMLFB", newTableData.txtMLFB);
    formData.append("txtDescription", newTableData.txtDescription);
    formData.append("txtItemNO", newTableData.txtItemNO);
    formData.append("txtDrawingNo", newTableData.txtDrawingNo);
    formData.append("NoOfWays", newTableData.NoOfWays);
    formData.append("txtCost", newTableData.txtCost);
    formData.append("txtMRP", newTableData.txtMRP);
    formData.append('DBSeries', newTableData.DBSeriesId);
    formData.append('DBType', newTableData.DBType)
    formData.append("userID", userdetails.userId);
    formData.append("Variants", newTableData.VariantsId);
    formData.append("Countries", newTableData.CountriesId);
    formData.append("IsActive", newTableData.isActive);


    setIsLoader(true);
    createStandardMLFB(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      formData
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          getTableData();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };
  const handleAddStdMlfb = useCallback(() => {
    setEditStdMlfb(null);
    setOpenDialog(true);
  }, []);

  const clearSearch = () => {
    setSearchText("");
    setRows(initialRows);
  };

  return (
    <>
      <Box sx={{ padding: "10px", border: "1px solid #ccc" }}>
        <Typography variant="h5" gutterBottom>
          Standard MLFB
        </Typography>

        <Grid container spacing={3} style={{
          marginTop: "5px",
          padding: "12px"
        }} >
          <Grid item xs={12} sm={6} md={6} style={{ maxWidth: "none" }}>
            <TextField
              className="name_wrapper "
              id="outlined-basic"
              label="MLFB"
              name="mlfb"
              value={mlfbSearch}
              variant="outlined"
              onChange={handleChangeMLFB}

            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} style={{ maxWidth: "none" }}>
            <TextField
              className="name_wrapper "
              id="outlined-basic"
              label="Description"
              name="description"
              value={descriptionSearch}
              variant="outlined"
              onChange={handleChangeDescription}
            //fullWidth

            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} style={{ maxWidth: "none" }}>
            <TextField
              className="name_wrapper "
              id="outlined-basic"
              label="Item No"
              name="itemNo"
              value={itemNoSearch}
              variant="outlined"
              onChange={handleChangeItemNo}
            //fullWidth

            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} style={{ maxWidth: "none" }}>
            <TextField
              className="name_wrapper "
              id="outlined-basic"
              label="Drawing No"
              name="drawingNo"
              value={drawingSearch}
              variant="outlined"
              onChange={handleChangeDrawingNo}
            //fullWidth

            />
          </Grid>
        </Grid>

        <Box sx={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "10px",
          marginBottom: "20px",
          maxWidth: "none"
        }}>
          <Button
            className="btn"
            variant="contained"
            onClick={handleSearChange}
          >
            Search
          </Button>
          <Button
            className="btn"
            variant="contained"
            onClick={handleReset}
          >
            Reset
          </Button>

          <SearchIcon color="action" />
          <TextField
            variant="standard"
            placeholder="Search"
            value={searchText}
            onChange={handleSearch}
            sx={{ marginLeft: "5px", width: "200px", width: "200px" }}
          />
          <IconButton onClick={clearSearch} size="small">
            <ClearIcon fontSize="small" />
          </IconButton>
          {userdetails.roleId === 2 ? <></> : <Tooltip title="Download excel" arrow disableInteractive>
            <IconButton onClick={() => exportToExcel()} size="small">
              <DownloadIcon />
            </IconButton>
          </Tooltip>}
          {userdetails.roleId !== 2 ? <div>
            <Button
              className="btn"
              variant="contained"
              onClick={handleAddStdMlfb}
            >
              Add
            </Button>
            <StandardMLFBPop
              open={openDialog}
              onClose={() => setOpenDialog(false)}
              onSave={handleSaveStdMlfb}
              onUpdate={handleUpdateStdMLFB}
              userToEdit={{ editStdMlfb }}
            />
          </div> : <></>}
        </Box>


        <div
          style={{
            height: 500,
            width: "100%",
            gap: "10px",
            paddingTop: "30px",
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.standardMLFBID}
            pageSize={4}
            rowsPerPageOptions={[4]}
            disableRowSelectionOnClick
            localeText={{
              noRowsLabel: "No Matching Records Found!",
            }}
            loading={isLoader}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#d3d3d3",
                fontWeight: "500",
                fontSize: "13px",
                color: "black",
                lineHeight: "1.5rem",
              },
              "& .MuiDataGrid-columnHeader": { backgroundColor: "#d3d3d3" },

              "& .MuiDataGrid-cell": {
                textAlign: "left",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiDataGrid-footerContainer": {
                fontSize: "12px",
              },
            }}
          />
          <>
            <SnackbarCustom
              open={open}
              message={snackMessage}
              alertType={alertType}
              handleClose={handleClose}
            />
          </>
          <Dialog
            open={openForDelete}
            onClose={handleCloseforDelete}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete the MLFB?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleCloseforDelete}
                className="pt-button--secondary"
              >
                Cancel
              </Button>
              <Button
                onClick={() => handleRowDelete()}
                className="pt-button--primary"
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Box>

      {loaderUploading ? <Loading /> : <></>}

    </>
  );
}
